<template>
    <div>
        <div class="card ">
            <div class="card-header main-card">
                Administración actividades y planificaciones
            </div>
            <div class="card-body">
                <!-- <Spinner v-if="isDataLoading" color="#fedd00" /> -->
                <div>
                    <div class="mb-4">
                        <p>Administrando un total de <strong>{{activities.length}} actividades</strong>, de las cuales: </p>
                        <ul class="ml-4">
                            <li class="mb-2">
                                <span>
                                    {{activeUnconfigured}} actividades con planificaciones activas requiren atención para terminar de configurar
                                </span>
                            </li>
                            <!-- <li class="mb-2">
                                <span> 
                                    {{activitiesReadyState}} están completamente configuradas y {{activitiesReviewState}} requieren atención
                                </span>
                            </li> -->
                            <li class="mb-2">
                                <span>
                                    {{listActiveActivities.length}} actividades tienen alguna planificación activa y {{listUnactiveActivities.length}} actividades no tienen ninguna planificación activa
                                </span>
                            </li>
                        </ul>
                        
                    </div>
                    <div class="d-flex justify-content-end my-4">
                        <div>
                            <b-button @click="syncActivitiesTrekksoft()" class="border text-right" variant="light">
                                <i v-if="!loadingSync" class="fa fa-cloud-download mr-2" aria-hidden="true"></i>
                                <i v-else class="fa fa-spinner fa-spin mr-2"></i>
                                <span>Sincronizar actividades y planificaciones (Trekksoft)</span>
                            </b-button>
                            <b-button @click="syncActivitiesZerotours()" class="border text-right ml-4" variant="light">
                                <i v-if="!loadingSync" class="fa fa-cloud-download mr-2" aria-hidden="true"></i>
                                <i v-else class="fa fa-spinner fa-spin mr-2"></i>
                                <span>Sincronizar actividades y planificaciones (Zerotours)</span>
                            </b-button>
                            <p v-if="loadingSync" class="text-right font-weight-bold text-danger">Sincronización en curso, espere unos instantes...</p>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end my-4">
                        <b-form-group label="Filtrar por sistema de procedencia" class="d-flex">
                            <b-form-radio-group v-model="filterActivities" id="radio-group-ver">
                                <b-form-radio name="ver-todo" :value="'all'">Todo</b-form-radio>
                                <b-form-radio name="ver-zerotours" :value="'zerotours'">Solo Zerotours</b-form-radio>
                                <b-form-radio name="ver-trekksoft" :value="'trekksoft'">Solo Trekksoft</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                    <table class="table table-hover table-bordered table-sm mt-1">
                        <thead>
                            <tr>
                                <th scope="col" title="Nombre de la actividad">Nombre</th>
                                <th scope="col" title="Identificador interno de la actividad">Id</th>
                                <th scope="col" title="Total de planificaciones (schedulers) configuradas para esta actividad">Total planificaciones</th>
                                <th scope="col" title="Número total de planificaciones configuradas para esta actividad">Planificaciones no configuradas</th>
                                <th scope="col" title="Indica si hay planificaciones activas para esta actividad. Si tiene, indica el número exacto">Planificaciones activas</th>
                                <th scope="col" title="Indica si la actividad está totalmente configurada (verde) o require atención (amarillo)">Estado</th>
                                <th scope="col" title="Sistema fuente de la actividad">Fuente</th>
                                <!-- <th scope="col" title="Duración de la actividad">Duración</th> -->
                                <th scope="col" title="Contiene only tickets">Contiene only tickets</th>
                                <th scope="col">Configurar</th>
                            </tr>
                        </thead>
                        <tbody v-if="!loading && !loadingSync">
                            <tr>
                                <td colspan="8">
                                    <p class="font-weight-bold">
                                        Actividades con planificaciones activas ({{listActiveActivities.length}})
                                    </p>
                                </td>
                            </tr>
                            <admin-activities-table-row v-for="activity in listActiveActivities" :key="activity.id" :row="activity" />

                            <tr>
                                <td colspan="8">
                                    <p class="font-weight-bold">
                                        Actividades con todas las planificaciones inactivas ({{listUnactiveActivities.length}})
                                    </p>
                                </td>
                            </tr>
                            <admin-activities-table-row v-for="activity in listUnactiveActivities" :key="activity.id" :row="activity" />
                        </tbody>
                        <tbody v-else>
                            Cargando datos...
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import AdminActivitiesTableRow from './AdminActivitiesTableRow'
import Spinner from "vue-spinner/src/ScaleLoader.vue";
import { mapGetters } from 'vuex';

export default {
    components: {
        AdminActivitiesTableRow,
        Spinner,
    },
    data() {
        return {
            loadingSync: false,
            loading: false,
            filterActivities: 'zerotours',
            listActiveActivities: [],
            listUnactiveActivities: []
        }
    },
    beforeDestroy() {
        this.$store.commit('activities/RESET_ACTIVITIES')
    },
    async created() {
        this.loading = true
        await this.getData()
        this.filterActivities = 'zerotours'
        this.populateActivities()
        this.loading = false
    },
    async mounted() {
        await this.$store.dispatch("suprazones/loadSuprazones")
        await this.$store.dispatch("groups/loadGroups");
        await this.$store.dispatch("geopoints/getAllGeopoints")
    },
    methods: {
        async getData() {
            await this.$store.dispatch("activities/get_activities")
            await this.$store.dispatch("activityDurationTypes/retrieveActivityDurationTypes")
        },
        async syncActivitiesTrekksoft() {
            this.loadingSync = true;
            try {
                await this.$store.dispatch("trekksoft/syncActivityData");
                this.$store.dispatch("activities/get_activities")
                this.$notify({
                    group: "foo",
                    title: "Actividades y planificaciones sincronizadas (Trekksoft)",
                    text: "Se han sincronizado las actividades y sus planificaciones desde Trekksoft",
                    type: "success"
                });
            } catch (ex) {
                this.loadingSync = false;
                this.error = "Failed to load data";
            } finally {
                this.loadingSync = false;
            }
        },
        async syncActivitiesZerotours() {
            this.loadingSync = true
            try {
                await this.$store.dispatch("activities/syncZTActivities")
                this.populateActivities()
                this.$notify({
                    group: "foo",
                    title: "Actividades y planificaciones sincronizadas (Zerotours)",
                    text: "Se han sincronizado las actividades y sus planificaciones desde Zerotours",
                    type: "success"
                });
            } catch (ex) {
                this.loadingSync = false;
                this.error = "Failed to load data";
            } finally {
                this.loadingSync = false;
            }
        },
        populateActivities() {
            this.listActiveActivities = this.activities.filter(
                item => item.count_active > 0
            )
            this.listUnactiveActivities = this.activities.filter(
                item => item.count_active == 0
            )
            console.log(this.listActiveActivities)
            if ( this.filterActivities != 'all' ) {
                this.listActiveActivities = this.listActiveActivities.filter(
                    (item) => item.source_integration == this.filterActivities
                )
                this.listUnactiveActivities = this.listUnactiveActivities.filter(
                    (item) => item.source_integration == this.filterActivities
                )
                console.log(this.listActiveActivities)
            } 
        }
    }, 
    computed: {
        ...mapGetters(["activities", 'isDataLoading']),
        activitiesReadyState() {
            let count = 0
            for ( let i in this.activities) {
                const activity = this.activities[i]
                if ( activity.count_unconfigured_schedulers == 0 ) {
                    count++
                }
            }
            return count
        },
        activitiesReviewState() {
            let count = 0
            for ( let i in this.activities) {
                const activity = this.activities[i]
                if ( activity.count_unconfigured_schedulers > 0 ) {
                    count++
                }
            }
            return count
        },
        listActiveActivitiesxx() {
            let results = this.activities.filter(
                item => item.count_active > 0
            )
            if ( this.filterActivities != 'all' ) {
                results.filter((item) => item.source_integration == this.filterActivities)
            }
            return results
        },
        listUnactiveActivitiesxx() {
            let results = this.activities.filter(
                item => item.count_active == 0
            )
            if ( this.filterActivities != 'all' ) {
                results.filter((item) => item.source_integration == this.filterActivities)
            }
            return results
        },
        activeUnconfigured() {
            let activeActivities = this.activities.filter(
                item => item.count_active > 0
            )
            let unconfiguredActiveActivities = activeActivities.filter(
                item => item.count_unconfigured_schedulers > 0
            )
            return unconfiguredActiveActivities.length
        }
    },
    watch: {
        filterActivities() {
            this.populateActivities()
        },
        activities() {
            console.log('watch activities changed')
            this.populateActivities()
        }
    }
}
</script>